import React from "react";
import styled from "styled-components";
import { Flex } from "rebass/styled-components";
import { HiOutlinePlusCircle } from "react-icons/hi";
import { useRecoilState } from "recoil";
import { MontageSession } from "MVVM/State";

export const SelectClipCard = ({
  openClipSelectorModal,
}: {
  openClipSelectorModal: () => void;
}) => {
  const [montageSession] = useRecoilState(MontageSession);
  const hasClips = montageSession.clips.length > 0;

  if (hasClips) {
    return (
      <CompactButton
        onClick={() => {
          openClipSelectorModal();
        }}
      >
        <CompactContentWrapper>
          <CompactAddIcon />
        </CompactContentWrapper>
      </CompactButton>
    );
  }

  return (
    <ClipHandle
      onClick={() => {
        openClipSelectorModal();
      }}
    >
      <ContentWrapper>
        <StyledAddIcon />
        <TextWrapper>
          <Title>Add a clip</Title>
          <Subtitle>Click here to select clips</Subtitle>
        </TextWrapper>
      </ContentWrapper>
    </ClipHandle>
  );
};

const StyledAddIcon = styled(HiOutlinePlusCircle)`
  width: 48px;
  height: 48px;
  aspect-ratio: 1/1;
  color: #4a6ea1;
  opacity: 0.6;
  margin-right: 16px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled.div`
  color: var(--Shade-100, #f9fafb);
  opacity: 0.7;

  /* Heading S */
  font-family: Barlow;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 133.333% */
`;

const Subtitle = styled.div`
  color: var(--Shade-300, #8fa9af);
  opacity: 0.6;

  /* Subheading M */
  font-family: Barlow;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
`;

const ClipHandle = styled(Flex)`
  display: flex;
  position: relative;
  height: 120px;
  width: 100%;
  border-radius: 14px;
  border: 2px dashed var(--Chalk-20, rgba(143, 169, 175, 0.2));
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.3s ease;
  margin-top: 15px;

  &:hover {
    border-color: #71aaff;
    background: rgba(113, 170, 255, 0.1);
  }

  &:hover ${StyledAddIcon} {
    color: #71aaff;
    opacity: 1;
  }

  &:hover ${Title} {
    color: #71aaff;
    opacity: 1;
  }

  &:hover ${Subtitle} {
    color: rgba(113, 170, 255, 0.8);
    opacity: 1;
  }
`;

const CompactAddIcon = styled(HiOutlinePlusCircle)`
  width: 25px;
  height: 25px;
  color: #71aaff;
  opacity: 0.5;
`;

const CompactButton = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  min-height: 48px;
  border-radius: 12px;
  background: rgba(113, 170, 255, 0.15);
  border: 1px solid rgba(113, 170, 255, 0.3);
  cursor: pointer;
  transition: 0.3s ease;
  margin-top: 15px;
  width: 100%;
  flex-shrink: 0;
  z-index: 100;

  &:hover {
    background: rgba(113, 170, 255, 0.25);
    border-color: rgba(113, 170, 255, 0.5);
  }

  &:hover ${CompactAddIcon} {
    opacity: 1;
  }
`;

const CompactContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
